// Define types for the brick menu structure
import {
   CheckBoxOutlineBlank,
   InsertPhoto,
   LocalShipping,
   ShoppingBasket,
   SmartButton,
   TextFields, ViewList
} from '@mui/icons-material';
import {
   Brick,
   BrickBox,
   BrickButton,
   BrickImage,
   BrickProducts,
   BrickShipping,
   BrickStatus,
   BrickText
} from './BrickMailType';

// Define the structure for brick type definitions
export interface BrickTypeDefinition {
   type: string;
   label: string;
   icon: any; // React component icon
   createDefault: () => Brick;
}

// Create the brick types configuration
export const BRICK_TYPES: BrickTypeDefinition[] = [
   {
      type: 'text',
      label: 'Text',
      icon: TextFields,
      createDefault: (): BrickText => ({
         text: true,
         value: 'New text content',
         fontSize: '14px',
         color: '#000000',
         align: 'center',
         padding: '0px 5px 0px 5px'
      })
   },
   {
      type: 'button',
      label: 'Button',
      icon: SmartButton,
      createDefault: (): BrickButton => ({
         button: true,
         value: 'Click Me',
         url: '#',
         backgroundColor: '#993300',
         color: '#FFFFFF',
         borderColor: '#FFFFFF',
         borderWidth: '2px',
         borderRadius: '0px',
         padding: '12px 30px',
         margin: '20px 0px',
         align: 'center',
         fullwidth: false
      })
   },
   {
      type: 'image',
      label: 'Image',
      icon: InsertPhoto,
      createDefault: (): BrickImage => ({
         image: true,
         title: 'New Image',
         url: 'https://storageaccountourimbea2.blob.core.windows.net/brandstatic/App_Icon3.png',
         align: 'center',
         disablePadding: false
      })
   },
   {
      type: 'box',
      label: 'Box',
      icon: CheckBoxOutlineBlank,
      createDefault: (): BrickBox => ({
         box: true,
         value: 'Box Content',
         backgroundColor: '#f0f0f0',
         color: '#000000',
         align: 'center',
         margin: '20px 0px 20px 0px',
         padding: '12px 30px',
         width: 'auto'
      })
   },
   {
      type: 'products',
      label: 'Products',
      icon: ShoppingBasket,
      createDefault: (): BrickProducts => ({
         products: true,
         title: 'Products'
      })
   },
   {
      type: 'shipping',
      label: 'Shipping',
      icon: LocalShipping,
      createDefault: (): BrickShipping => ({
         shipping: true,
         qrImageTitle: 'QR Code',
         qrDownloadTitle: 'Download QR Code',
         qrDownloadButtonTitle: 'Download QR',
         shippingTitle: 'Shipping Label',
         shippingButtonTitle: 'Download Label',
         labelCodeTitle: 'Package Code',
         layoutText: {
            color: '#000000',
            fontSize: '14px',
            align: 'center'
         },
         layoutButton: {
            backgroundColor: '#993300',
            color: '#FFFFFF',
            borderColor: '#FFFFFF',
            align: 'center',
            padding: '12px 30px'
         },
         align: 'center',
         margin: '0px 5px 0px 5px'
      })
   },
   {
      type: 'status',
      label: 'Status',
      icon: ViewList,
      createDefault: (): BrickStatus => ({
         status: true,
         fontSize: '14px',
         color: '#000000',
         align: 'center',
         margin: '0px 5px 0px 5px',
         blocks: {
            TITLE: {
               text: 'Trade-in Items',
               color: '#000000',
               fontSize: '18px',
               fontWeight: 'bold'
            },
            DESCRIPTION: {
               text: 'Here are the items you have traded in and their status',
               color: '#000000'
            },
            SUMTOTAL: {
               text: 'Total value:',
               color: '#000000',
               fontWeight: 'bold'
            },
            VOUCHER: {
               text: '{{voucherValue}}',
               color: '#993300',
               fontWeight: 'bold'
            },
            ITEM: {
               text: '{{title}}',
               color: '#000000'
            },
            OKAY: {
               text: 'Approved',
               color: '#008800'
            },
            REJECTDEFAULT: {
               text: 'Not approved',
               color: '#FF0000'
            }
         }
      })
   }
];

// Helper function to find brick type definition
export const getBrickTypeDefinition = (type: string): BrickTypeDefinition | undefined => {
   return BRICK_TYPES.find(brickType => brickType.type === type);
};

// Helper function to create a new brick of specific type
export const createNewBrick = (type: string): Brick | null => {
   const brickTypeDefinition = getBrickTypeDefinition(type);
   if (!brickTypeDefinition) return null;
   return brickTypeDefinition.createDefault();
};